// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class EnrollmentNetStandardCaseRelationshipModel {
    static getAttributeTypeMap() {
        return EnrollmentNetStandardCaseRelationshipModel.attributeTypeMap;
    }
}
EnrollmentNetStandardCaseRelationshipModel.discriminator = undefined;
EnrollmentNetStandardCaseRelationshipModel.additionalProperties = false;
EnrollmentNetStandardCaseRelationshipModel.attributeTypeMap = [
    {
        "name": "partyRoleId",
        "baseName": "partyRoleId",
        "type": "number"
    },
    {
        "name": "isPrimary",
        "baseName": "isPrimary",
        "type": "boolean"
    },
];
//# sourceMappingURL=enrollmentNetStandardCaseRelationshipModel.js.map